var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"my-td3-box",class:{'td3-body-bg':_vm.tdType == 'body'},attrs:{"tdWidth":_vm.tdWidth},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{ref:"td",staticClass:"my-td3-box-inner",class:{'overflow':_vm.overflow}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }